import * as React from 'react'

import { cn } from '@/lib/utils'

const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.TextareaHTMLAttributes<HTMLTextAreaElement> & {
    /** `encuentro`: same field as the Encuentro `Input`, for `Field multiline`. */
    look?: 'classic' | 'encuentro'
  }
>(({ className, look, ...props }, ref) => {
  return (
    <textarea
      data-look={look === 'encuentro' ? 'encuentro' : undefined}
      className={cn(
        'flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
        look === 'encuentro' &&
          'min-h-28 rounded-en-md border-en-line-control bg-en-surface px-4 py-3 font-en-sans text-en-body text-en-ink ring-offset-0 placeholder:text-en-ink-muted focus-visible:ring-0 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-solid focus-visible:outline-en-focus aria-invalid:border-en-danger aria-invalid:shadow-[0_0_0_1px_var(--en-danger)] disabled:opacity-45',
        className
      )}
      ref={ref}
      {...props}
    />
  )
})
Textarea.displayName = 'Textarea'

export { Textarea }
